const config = {
    layout: 'vertical', // vertical, horizontal
    collapseMenu: false, // mini-menu
    layoutType: 'menu-dark', // menu-dark, menu-light
    headerBackColor: 'header-dark', // header-blue, header-red, header-purple, header-info, header-dark
    fullWidthLayout: true,
    navFixedLayout: true,
    headerFixedLayout: true
};

export default config;